﻿import React from 'react';
import { useTranslation } from 'react-i18next';

import Popup from '@Elements/Popup/Popup';
import { Button } from '@Elements/Buttons';

import { str_isEmpty } from '@Util/Utils';
import { Prompt_Information_Type } from '@Util/Types';

export default function Action_Prompt(props: Prompt_Information_Type): JSX.Element {
    const [t] = useTranslation();

    return (
        <Popup
            open={props.open}
            set_open={props.on_cancel_action}
            title={props.prompt_headline}
            disable_close_action={false}
        >
            {
                !str_isEmpty(props.prompt_text) &&
                <p>{props.prompt_text}</p>
            }
            <div className="Popup_Actions">
                <Button color="Transparent" onClick={() => props.on_cancel_action()}>
                    {t('Button.Cancel')}
                </Button>
                <Button color="Red" onClick={props.on_accept_action}>
                    {t('Button.Confirm')}
                </Button>
            </div>
        </Popup>
    );
}